import api from "./api.js";

export default class ConsultingApi {
  // 컨설팅 사전 상담 받기
  static async addMyConsulting(data) {
    return await api.post(`api/consulting`, data);
  }

  static async getMyConsultingList(data) {
    return await api.get(`api/consulting`, data);
  }

  static async getMyConsultingDetail(id) {
    return await api.get(`api/consulting/${id}`);
  }

  // 컨설팅 필요 서류 제출
  static async addMyConsultingFile(id, data) {
    return await api.patch(`api/consulting/${id}`, data);
  }

  // 컨설팅-상품
  static async getList(data) {
    return await api.get(`api/consulting-merch`, data);
  }

  static async getDetail(id, data) {
    return await api.get(`api/consulting-merch/${id}`, data);
  }

  static async putScrap(data) {
    return await api.patch(`api/consulting-scrap`, data);
  }
}
